import { post } from "../../service/api";

const FindUserOfInvoice = async (id) => {
    try {
        const response = await post(`/invoice/${id}/findUser`);
        return response;
    } catch (error) {
        console.error('Error FindUserOfInvoice:', error);
        throw error;
    }
};

export default FindUserOfInvoice;